import HydroDateInput from "./HydroDateInput";

const CheckpointField = ({ checkpoint, value, onChange, readOnly = false }) => {
  const formatLabel = (value) => {
    if (!value) return "";

    // If value is purely numeric → add kg
    if (!isNaN(value)) {
      return `${value} kg`;
    }

    // Otherwise format enum style
    return value
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const renderOptions = (options) => (
    <div className="flex gap-1 md:gap-2">
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          disabled={readOnly}
          onClick={() => onChange(opt)}
          className={`px-1 md:px-4 rounded-full border transition text-[10px] md:text-sm py-[2px] capitalize disabled:pointer-events-none
          ${
            value.toLowerCase() === opt.toLowerCase()
              ? "bg-blue-100 text-blue-600 border-blue-300"
              : "bg-white hover:bg-gray-100"
          }`}
        >
          {formatLabel(opt)}
        </button>
      ))}
    </div>
  );

  const renderInput = () => {
    switch (checkpoint.inputType) {
      case "yes_no":
        return renderOptions(["yes", "no"]);

      case "enum":
        return renderOptions(checkpoint.valueOptions);

      case "checkbox":
        return (
          <label className="flex items-center gap-1 md:gap-2">
            <input
              type="checkbox"
              className={`w-3 h-3 md:w-5 md:h-5 ${readOnly ? "accent-green-3" : "accent-dark-blue"}`}
              checked={!!value}
              onChange={(e) => onChange(e.target.checked)}
            />
            <span className="text-sm">Completed</span>
          </label>
        );

      case "number":
        const handleChange = (e) => {
          const val = e.target.value;
          // Allow numbers with optional decimal
          if (/^\d*\.?\d*$/.test(val)) {
            // Prevent 0 as value
            if (val === "" || Number(val) > 0) {
              onChange(val);
            }
          }
        };

        return (
          <input
            type="text"
            disabled={readOnly}
            className="px-2 py-1 border rounded-md focus-input text-sm"
            value={readOnly ? `${value} kg` : value}
            onChange={handleChange}
            placeholder="Enter weight in kg"
            inputMode="numeric"
            pattern="[0-9]*"
          />
        );
      case "date":
        return <HydroDateInput value={value} setValue={onChange} />;

      default:
        return null;
    }
  };

  return renderInput();
};

export default CheckpointField;
